import API from './API.js'

export default class QuranProgramsWithUsers extends API {
  constructor() {
    super('quran-programs-with-users')
  }
    
  
}
